import React from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: <Compass className="w-6 h-6 text-gold" data-id="element-126" />,
    text: 'Apply them to real life'
  }];
  return <section className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-127">
      {/* Top divider — gold accent line */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-gold/60 to-transparent" data-id="element-128" />

      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] bg-gold/8 rounded-full blur-[150px] pointer-events-none" data-id="element-129" />

      {/* Subtle radial pattern overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(201,168,76,0.06)_0%,transparent_60%)] pointer-events-none" data-id="element-130" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-132">
          {/* Introducing label */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="inline-block mb-6 px-4 py-1.5 rounded-full border border-gold/30 bg-gold/5 text-gold-light text-sm font-medium tracking-widest uppercase" data-id="element-133">
            Introducing
          </motion.div>

          {/* Main title with gold gradient */}
          <motion.h2 initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-5xl sm:text-6xl md:text-7xl font-bold mb-6 leading-tight" data-id="element-134">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold via-gold-light to-gold" data-id="element-135">
              The Dream
            </span>
            <br data-id="element-136" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-light via-white to-gold-light" data-id="element-137">
              Decoding System
              <span className="align-super opacity-40 text-[20px] text-[#FFFFFF] bg-[#0C0A0A]" data-id="element-138">
                ™
              </span>
            </span>
          </motion.h2>

          {/* Decorative line under title */}
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="w-24 h-[2px] bg-gradient-to-r from-gold/0 via-gold to-gold/0 mx-auto mb-8" data-id="element-139" />

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-xl sm:text-2xl text-zinc-400 max-w-2xl mx-auto font-light" data-id="element-140">
            A structured framework to:
          </motion.p>
        </motion.div>

        <div className="grid grid-cols-1 gap-8 max-w-md mx-auto" data-id="element-141">
          {features.map((feature, index) => {})}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-dark-border to-transparent" data-id="element-142" />
    </section>;
}